
import {
    GALERIA_LOADING,
    GALERIA_LOADED,
    GALERIA_ERROR,
    
    CREARGALERIA_ERROR,
    CREARGALERIA_LOADED,
    CREARGALERIA_LOADING,
    
    EDITARGALERIA_ERROR,
    EDITARGALERIA_LOADED,
    EDITARGALERIA_LOADING,
    
    DELETEGALERIA_ERROR,
    DELETEGALERIA_LOADED,
    DELETEGALERIA_LOADING,

    USER_GALERIA_GET_LOADING,
    USER_GALERIA_GET_LOADED,
    USER_GALERIA_GET_ERROR
    
  } from '../../types/galeriatypes';

const INITIAL_STATE = {
    isLoading: false,
    galeria: null,
    creargaleria: [],
    editgaleria: [],
    isLoaded: false,
    isImageEdited: false,
    isCreated: false,
    imagenes: [],
    error: '',
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type){
        case USER_GALERIA_GET_LOADING:
            return {
                ... state,
                isLoading: true,
                isLoaded: false,
                error: '',
            }
        case USER_GALERIA_GET_LOADED:
            return {
                ...state,
                isLoading: false,
                isLoaded: true,
                imagenes: action.payload,
                error: '',
            };
        case USER_GALERIA_GET_ERROR:
            return {
                ...state,
                isLoading: false,
                isLoaded: false,
                error: action.payload,
            }

        case GALERIA_LOADING:
            return {
                ... state,
                isLoading : true,
                galeria: null,
                error: ''
            }
        case GALERIA_LOADED:
            return {
                ...state,
                galeria: action.payload,
                error: '',
                isLoading: false
            };
        case GALERIA_ERROR:
            return {
                ...state,
                galeria: null,
                isLoading: false,
                error: action.payload,
            }

        case CREARGALERIA_LOADING:
            return {
                ... state,
                isLoading : true,
                creargaleria : null,
                isCreated: false,
                error: ''
            }
        case CREARGALERIA_LOADED:
            return {
                ... state,
                isLoading : false,
                isCreated: true,
                creargaleria: action.payload,
                error: ''
            };
        case CREARGALERIA_ERROR:
            return {
                ...state,
                creargaleria : null,
                isLoading : false,
                isCreated: false,
                error: action.payload,
            }

        case EDITARGALERIA_LOADING:
            return {
                ... state,
                isLoading : true,
                isImageEdited: false,
                error: ''
            }
        case EDITARGALERIA_LOADED:
            return {
                ... state,
                isLoading : false,
                editgaleria: action.payload,
                isImageEdited: true,
                error: ''
            };
        case EDITARGALERIA_ERROR:
            return {
                ...state,
                isLoading : false,
                isImageEdited: false,
                error: action.payload,
            }

        case DELETEGALERIA_LOADING:
            return {
                ... state,
                isLoading : true,
                creargaleria : null,
                error: ''
            }
        case DELETEGALERIA_LOADED:
            return {
                ... state,
                isLoading : false,
                creargaleria: action.payload,
                error: ''
            };
        case DELETEGALERIA_ERROR:
            return {
                ...state,
                creargaleria : null,
                isLoading : false,
                error: action.payload,
            }
        default: return state;
    }
}